<div class="h-full overflow-hidden">
  <p-scroll-panel class="h-full">
    <form [formGroup]="form">
      <div class="control">
        <label>Regnr.</label>
        <input pInputText formControlName="regnr" />
      </div>
      <div class="control">
        <label>Kørsel nr</label>
        <input pInputText formControlName="koerselsNr" />
      </div>
      <div class="control">
        <label>Cpr nummer</label>
        <app-let-input-cpr formControlName="cprNummer" />
      </div>
      <div class="control">
        <label>Ikke afsendte kørsler</label>
        <p-checkbox formControlName="ikkeAfsendte" [binary]="true" />
      </div>

      <div class="flex gap-2">
        <p-button
          label="Søg"
          (click)="onClickSearch()"
          [loading]="opkraevningsListerService.datasource.isLoading()"
          icon="pi pi-search"
          type="submit" />
        <p-button
          label="Nulstil"
          (click)="onClickReset()"
          icon="pi pi-times"
          severity="secondary"
          outlined />
      </div>
    </form>
    @if (noHits()) {
      <p-message text="Ingen hits" severity="error" styleClass="mt-4" />
    }
  </p-scroll-panel>
</div>
